import { defaultIconProps, IconProps } from './IconProps';

export const IconGrok: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.934 15.2984L26.58 36.0417H20.0701L5.42401 15.2984H11.934ZM11.9282 26.8192L15.1846 31.4334L11.9311 36.0417H5.41672L11.9282 26.8192ZM34.5834 6.26544V36.0417H29.2473V13.8225L34.5834 6.26544ZM34.5834 3.95836L20.0701 24.5136L16.8136 19.9009L28.069 3.95836H34.5834Z"
      fill="black"
    />
  </svg>
);

IconGrok.defaultProps = defaultIconProps;
